import {PropsWithChildren} from 'react';
import {Spinner} from 'react-bootstrap';

interface LoadingOverlayProps {
  isLoading: boolean;
}

const LoadingOverlay = ({
  isLoading,
  children,
}: PropsWithChildren<LoadingOverlayProps>): JSX.Element => (
  <div className={isLoading ? 'blockui' : undefined}>
    {children}
    {isLoading && (
      <div className="blockui-overlay">
        <Spinner animation="border" />
      </div>
    )}
  </div>
);

export default LoadingOverlay;
